import { Box, Button, Card, Grid, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useState } from "react";
import { post_form_data } from "../../../services/FetchHelper";
import EntityConstants from "../../../configs/EntityConstants";
import GoTable from "../../../common/GoTable/GoTable";
import SpinService from "../../../services/SpinService";

const tableHeaders = [
    { id: 'name', label: 'Name', align: 'left', type: "text" },
    { id: 'message', label: 'Message', align: 'left', type: "text" },
]

const notes = [
    "Download CSV by clicking download button",
    "Required column with * symbol"
]

const LocationUpload = () => {
    const spinService = SpinService();
    const formData = new FormData();
    const [selectedFile, setSelectedFile] = useState(null);
    const [results, setResults] = useState([]);

    const handleFileUpload = (event) => {
        if (event.target.files.length > 0) {
            setSelectedFile(event.target.files[0])
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        spinService.on();
        formData.append("file", selectedFile);
        const response = await post_form_data(EntityConstants.CSV_AREA_UPLOAD, formData);
        const data = await response.json();
        spinService.off();
        setResults(data);
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="h6">Notes</Typography>
                    <Box
                    // sx={{
                    //     height: '50vh',
                    // }}
                    >
                        <List>
                            {
                                notes.map((note, index) => {
                                    return <ListItem key={index} disablePadding>
                                        <ListItemButton>
                                            <ListItemText id={index} primary={note} />
                                        </ListItemButton>
                                    </ListItem>
                                })
                            }
                        </List>
                    </Box>
                </Grid>
                <Grid item xs={6}>

                    <Typography variant="h6">Form Fields</Typography>
                    <Box
                    // sx={{
                    //     display: 'flex',
                    //     justifyContent: 'center',
                    //     alignItems: 'center',
                    //     height: '50vh',
                    // }}
                    >
                        <Box sx={{ p: 2, textAlign: "center" }}>
                            {/* <Typography variant="h6">Upload a file</Typography> */}
                            {selectedFile && (
                                <Typography variant="body1">Selected File: {selectedFile.name}</Typography>
                            )}
                            <input
                                type="file"
                                onChange={handleFileUpload}
                                style={{ display: 'none' }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload">
                                <Button variant="contained" component="span" color="warning">
                                    Choose File
                                </Button>
                            </label>
                        </Box>


                    </Box>
                    <Box sx={{ p: 2, textAlign: "right" }}>
                        <Button disabled={selectedFile === null} variant="contained" component="span" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <br />
            {results.length > 0 && <Typography variant="h6">Result</Typography>}
            {
                results.length > 0 && <Card>
                    <GoTable
                        tableHeads={tableHeaders}
                        tableDatas={results}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            }
        </div>
    );
};

export default LocationUpload;